import "./medicalStaffProfile.scss";
import React, { useCallback, useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import {
  Container,
  Box,
  Alert,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Stack,
  Typography,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import { PageLayout } from "../../../components/page/page-layout";
import { useFormik } from "formik";
import axios from "axios";

import LoadingButton from "@mui/lab/LoadingButton";
import { DoctorMyInfoSchema } from "../../../helpers/validation";
import { API_BASE_URL } from "../../../constants/apiConstants";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import provincias from "../../../constants/provincias";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline"; // Importa el icono de borrado
import CloudUploadIcon from "@mui/icons-material/CloudUpload"; // Importa el icono de carga
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import CloudDownloadOutlinedIcon from "@mui/icons-material/CloudDownloadOutlined";
import { estadosArr } from "../../../constants/estados";
import { logoutDoctor, getDecryptedDataFromSessionStorage } from "../../../utils";
import { SECRET_KEY } from "../../../constants/encriptKey";

const MedicalStaffProfile = () => {
  const { uId } = useParams();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [userData, setUserData] = useState(null);
  const [approve, setApprove] = useState(null);
  const [pageLoaded, setPageLoaded] = useState(false);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);
  const [sendEmail, setSendEmail] = useState(false);
  const estadosValidos = ["2", "3", "4"];
  const [visibility, setVisibility] = useState(true);
  const [estado, setEstado] = useState("");
  const [filterStates, setFilterStates] = useState("");

  useEffect(() => {
    if (message) {
      setIsSnackbarOpen(true);
      const timerId = setTimeout(() => {
        setIsSnackbarOpen(false);
      }, 5000);
      return () => clearTimeout(timerId); // Limpiar el temporizador al desmontar el componente
    } else {
      setIsSnackbarOpen(false); // Asegurarse de que el Snackbar se cierre cuando no hay mensaje
    }
  }, [message]);

  const VisuallyHiddenInput = styled("input")({
    clip: "rect(0 0 0 0)",
    clipPath: "inset(50%)",
    height: 1,
    overflow: "hidden",
    position: "absolute",
    bottom: 0,
    left: 0,
    whiteSpace: "nowrap",
    width: 1,
  });

  const handleChangeUploadDocumentation = async (event) => {
    const fileSize = event.target.files[0].size;

    if (fileSize > 2000000) {
      setMessage({
        alertType: "document",
        type: "error",
        text: `El archivo seleccionado excede el tamaño máximo permitido de 2 MB. Por favor, seleccione un archivo más pequeño.`,
      });
      return;
    }

    try {
      const idMedico = uId; //localStorage.getItem("idMedico");
      const formData = new FormData();
      formData.append("IdMedico", idMedico);
      formData.append("Imagen", event.target.files[0]); // Asume que solo se selecciona un archivo

      const response = await axios.post(
        `${API_BASE_URL}Medicos/AgregaDocumentacion`,
        formData,
        {
          headers: {
            accept: "text/plain",
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === "Ok") {
        fetchData();
        setMessage({
          alertType: "document",
          type: "success",
          text: response.data.successMessage,
        });
      } else {
        setMessage({
          alertType: "document",
          type: "error",
          text: response.data.errors[0],
        });
        console.error("Error en la carga:", response.data.errors);
      }
    } catch (error) {
      console.error("Error al manejar el cambio de archivos:", error);
    }
  };

  const handleDeleteDocument = async (docId) => {
    try {
      if (approve) {
        console.log(
          "No puedes eliminar documentos cuando la aprobación es true."
        );
        return;
      }

      const idMedico = uId; //localStorage.getItem("idMedico");
      const currentDocumentCount = userData.documentacion.length;
      if (currentDocumentCount <= 1) {
        setMessage({
          alertType: "document",
          type: "error",
          text: "Debes dejar al menos un documento existente.",
        });
        console.log("Debes dejar al menos un documento existente.");
        return;
      }
      console.log(`Eliminar documento con ID: ${docId}`);

      const response = await axios.delete(
        `${API_BASE_URL}Medicos/EliminaDocumentacion`,
        {
          headers: {
            accept: "text/plain",
            "Content-Type": "application/json",
          },
          data: {
            idMedico: idMedico,
            idDocumentacion: docId,
          },
        }
      );

      if (response.data.status === "Ok") {
        const updatedDocuments = userData.documentacion.filter(
          (d) => d.id !== docId
        );
        setUserData((prevData) => ({
          ...prevData,
          documentacion: updatedDocuments,
        }));
        setMessage({
          alertType: "document",
          type: "success",
          text: "Documento eliminado con éxito",
        });
        console.log("Documento eliminado con éxito");
      } else {
        setMessage({
          alertType: "document",
          type: "error",
          text: `${response.data.errors[0]}`,
        });
        console.error("Error al eliminar el documento");
      }
    } catch (error) {
      console.error("Error al eliminar el documento", error);
    }
  };

  const handleClickDocumentation = (s3Link) => {
    const url = /^https?:\/\//i.test(s3Link) ? s3Link : `https://${s3Link}`;
    window.open(url, "_blank");
  };

  const actualizaMedico = async (formData) => {
    try {
      const idMedico = uId; //localStorage.getItem("idMedico");
      const email = userData.email;
      const userNameBo = localStorage.getItem("email");
      setVisibility(false);

      formData.fechaNacimiento = new Date(
        formData.fechaNacimiento
      ).toISOString();

      const response = await axios.put(
        `${API_BASE_URL}backoffice/Medicos/ActualizaMedicoBO`,
        {
          ...formData,
          idMedico: idMedico,
          email: email,
          userNameBO: userNameBo,
        },
        {
          headers: {
            accept: "text/plain",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data; // Puedes devolver la respuesta si es necesario
    } catch (error) {
      console.error("Error al actualizar médico:", error);
      throw error; // Puedes lanzar el error para que sea manejado por el componente que llama a esta función
    }
  };

  const formik = useFormik({
    initialValues: {
      name: "",
      lastname: "",
      specialty: "",
      birthdate: "",
      sex: "",
      phone: "",
      address: "",
      estado: "",
      mensaje: "",
    },
    validationSchema: DoctorMyInfoSchema,
    onSubmit: async (values) => {
      setEstado(Number(values.estado));
      try {
        setLoading(true);

        const idMedico = uId; //localStorage.getItem("idMedico");
        const email = userData.email;

        let formData = {
          idMedico: idMedico,
          nombre: values.name,
          apellido: values.lastname,
          especialidad: values.specialty,
          telefono: values.phone,
          email: email,
          direccionConsultorio: values.address,
          fechaNacimiento: values.birthdate,
          sexo: values.sex,
          pais: "",
          estado: Number(values.estado),
          enviaMail: sendEmail,
        };

        if (values.estado !== userData.estado) {
          formData.estadoAnterior = userData.estado;
        }

        if (values.mensaje) {
          formData.mensaje = values.mensaje;
        }

        await actualizaMedico(formData);

        values.mensaje = "";
        setMessage({
          type: "success",
          text: "¡Información actualizada con éxito!",
        });
      } catch (error) {
        setMessage({
          type: "error",
          text: "Hubo un error al actualizar la información.",
        });
      } finally {
        setLoading(false);
      }
    },
  });

  const fetchData = async () => {
    try {
      const idMedico = uId;
      const { accessToken } = getDecryptedDataFromSessionStorage(SECRET_KEY);

      const response = await axios.get(
        `${API_BASE_URL}Medicos/ConsultaMedico/${idMedico}`,
        {
          headers: {
            accept: "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
        }
      );

      if (response.data?.status === "Ok") {
        const data = response.data.result;
        setUserData(data);
        setApprove(response.data.result.aprobado?.toLowerCase() === "true");
        setEstado(data.estado);

        const formattedBirthdate = data?.fechaNacimiento
          ? new Date(data?.fechaNacimiento).toISOString().split("T")[0]
          : "1900-01-01";

        formik.setValues({
          name: data?.nombre || "",
          lastname: data?.apellido || "",
          dni: data?.dni || "",
          registrationType: data?.tipoMatricula || "",
          registrationNumber: data?.numeroMatricula || "",
          province: data?.provinciaMatricula || "",
          specialty: data?.especialidad || "",
          birthdate: formattedBirthdate,
          sex: data?.sexo || "",
          phone: data?.telefono || "",
          address: data?.direccionConsultorio || "",
          estado: data?.estado,
        });
      } else if (response.data?.status === "Error") {
        logoutDoctor();
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Error al cargar la información del médico", error);
    } finally {
      setPageLoaded(true);
    }
  };

  // Actualiza sendEmail cuando formik.values.estado cambia
  useEffect(() => {
    if (estadosValidos.includes(formik.values.estado)) {
      setSendEmail(true);
    } else {
      setSendEmail(false);
    }
    setVisibility(true);
  }, [formik.values.estado]);

  const filterByValue = () => {
    const filterValuesMap = {
      1: [1, 3],
      2: [2, 0, 3, 4],
      3: [3],
      4: [4],
      0: [0, 1, 3, 4],
    };

    const filterValues = filterValuesMap[estado] || [];
    return estadosArr.filter((item) => filterValues.includes(item.value));
  };

  useEffect(() => {
    setFilterStates(filterByValue);
  }, [userData, estado]);

  const handleChangeCheckBox = () => {
    setSendEmail(!sendEmail);
  };

  const renderMotivoInput = useCallback(() => {
    if (estadosValidos.includes(formik.values.estado) && visibility) {
      return (
        <Grid container spacing={3} mt={0.5}>
          <Grid item md={4} xs={12} alignContent={"center"}>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={handleChangeCheckBox}
                  checked={sendEmail}
                  inputProps={{ "aria-label": "controlled" }}
                />
              }
              label="Enviar email"
            />
          </Grid>
          <Grid item md={4} xs={12}>
            <TextField
              variant="outlined"
              fullWidth
              placeholder="Ingrese el motivo"
              label="Motivo"
              name="mensaje"
              onChange={formik.handleChange}
              value={formik.values.mensaje}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "7px",
                  border: "1px solid #65748B",
                  "&.Mui-focused": {
                    border: "2px solid #005B9A",
                  },
                },
                "& .MuiInputLabel-root": {
                  backgroundColor: "white",
                  padding: "0 4px",
                },
                "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
                  transform: "translate(14px, -6px) scale(0.75)",
                  backgroundColor: "white",
                  padding: "0 4px",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
              }}
            />
          </Grid>
        </Grid>
      );
    }
    return null;
  }, [formik.values.estado, sendEmail, visibility, formik.values.mensaje]);

  useEffect(() => {
    fetchData();
  }, []);

  if (!pageLoaded) {
    return (
      <PageLayout>
        <Container maxWidth="lg">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "100vh",
            }}
          >
            <CircularProgress />
          </Box>
        </Container>
      </PageLayout>
    );
  }
  return (
    <PageLayout>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 2,
        }}
      >
        <Container maxWidth={false}>
          <form onSubmit={formik.handleSubmit}>
            <Card
              sx={{
                border: "0.5px solid #dddddd",
                padding: "1px",
                boxShadow: "1px 1px #dddddd",
              }}
            >
              <CardHeader
                subheader="En esta sección podrá ver y actualizar la información del médico"
                title="Información del Médico"
              />
              <Divider />
              <CardContent>
                <Grid container spacing={3}>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(formik.touched.name && formik.errors.name)}
                      fullWidth
                      helperText={formik.touched.name && formik.errors.name}
                      label="Nombre"
                      name="name"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.name}
                      variant="outlined"
                      disabled={approve}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "text.primary",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(
                        formik.touched.lastname && formik.errors.lastname
                      )}
                      fullWidth
                      helperText={
                        formik.touched.lastname && formik.errors.lastname
                      }
                      label="Apellido"
                      name="lastname"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.lastname}
                      variant="outlined"
                      disabled={approve}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "text.primary",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(formik.touched.dni && formik.errors.dni)}
                      fullWidth
                      helperText={formik.touched.dni && formik.errors.dni}
                      label="Número de DNI"
                      name="dni"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.dni}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      sx={{ my: 1, marginBottom: 2 }}
                    >
                      <InputLabel
                        htmlFor="registrationType"
                        sx={{ color: "text.primary" }}
                      >
                        Tipo de Matrícula
                      </InputLabel>
                      <Select
                        native
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.registrationType}
                        label="Tipo de Matrícula"
                        inputProps={{
                          name: "registrationType",
                          id: "registrationType",
                        }}
                        sx={{ color: "text.primary" }}
                        error={Boolean(
                          formik.touched.registrationType &&
                            formik.errors.registrationType
                        )}
                        disabled
                      >
                        <option value=""></option>
                        <option value="MN">Matrícula Nacional</option>
                        <option value="MP">Matrícula Provincial</option>
                      </Select>
                      {formik.touched.registrationType &&
                        formik.errors.registrationType && (
                          <Typography
                            color="error"
                            variant="body2"
                            sx={{ fontSize: "0.8rem", ml: 1.5, mt: 0.5 }}
                          >
                            {formik.errors.registrationType}
                          </Typography>
                        )}
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(
                        formik.touched.registrationNumber &&
                          formik.errors.registrationNumber
                      )}
                      fullWidth
                      helperText={
                        formik.touched.registrationNumber &&
                        formik.errors.registrationNumber
                      }
                      label="Número de matrícula"
                      name="registrationNumber"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.registrationNumber}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      sx={{ my: 1, marginBottom: 2 }}
                    >
                      <InputLabel
                        htmlFor="provincia"
                        sx={{ color: "text.primary" }}
                      >
                        Provincia
                      </InputLabel>
                      <Select
                        native
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.province}
                        label="Provincia"
                        inputProps={{
                          name: "province",
                          id: "provincia",
                        }}
                        sx={{ color: "text.primary" }}
                        error={Boolean(
                          formik.touched.province && formik.errors.province
                        )}
                        disabled
                      >
                        <option value=""></option>
                        {provincias?.map((prov) => (
                          <option key={prov.sisa} value={prov.recipe}>
                            {prov.sisa}
                          </option>
                        ))}
                      </Select>
                      {formik.touched.province && formik.errors.province && (
                        <Typography
                          color="error"
                          variant="body2"
                          sx={{ fontSize: "0.8rem", ml: 1.5, mt: 0.5 }}
                        >
                          {formik.errors.province}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(
                        formik.touched.specialty && formik.errors.specialty
                      )}
                      fullWidth
                      helperText={
                        formik.touched.specialty && formik.errors.specialty
                      }
                      label="Especialidad"
                      name="specialty"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.specialty}
                      variant="outlined"
                      disabled
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      type="date"
                      error={Boolean(
                        formik.touched.birthdate && formik.errors.birthdate
                      )}
                      fullWidth
                      helperText={
                        formik.touched.birthdate && formik.errors.birthdate
                      }
                      label="Fecha de nacimiento"
                      name="birthdate"
                      onBlur={formik.handleBlur}
                      onChange={(e) =>
                        formik.setFieldValue("birthdate", e.target.value)
                      }
                      value={formik.values.birthdate}
                      variant="outlined"
                      disabled={approve}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "text.primary",
                          },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      sx={{ my: 1, marginBottom: 2 }}
                    >
                      <TextField
                        select
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.sex}
                        label="Sexo"
                        error={Boolean(formik.touched.sex && formik.errors.sex)}
                        disabled={approve}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "text.primary",
                            },
                          },
                        }}
                      >
                        <MenuItem value=""></MenuItem>
                        <MenuItem value="F">Femenino</MenuItem>
                        <MenuItem value="M">Masculino</MenuItem>
                        <MenuItem value="X">Otro</MenuItem>
                      </TextField>
                      {formik.touched.sex && formik.errors.sex && (
                        <Typography
                          color="error"
                          variant="body2"
                          sx={{ fontSize: "0.8rem", ml: 1.5, mt: 0.5 }}
                        >
                          {formik.errors.sex}
                        </Typography>
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(
                        formik.touched.phone && formik.errors.phone
                      )}
                      fullWidth
                      helperText={formik.touched.phone && formik.errors.phone}
                      label="Teléfono"
                      name="phone"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.phone}
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "text.primary",
                          },
                        },
                      }}
                    />
                  </Grid>
                  <Grid item md={4} xs={12}>
                    <TextField
                      error={Boolean(
                        formik.touched.address && formik.errors.address
                      )}
                      fullWidth
                      helperText={
                        formik.touched.address && formik.errors.address
                      }
                      label="Dirección del consultorio"
                      name="address"
                      onBlur={formik.handleBlur}
                      onChange={formik.handleChange}
                      value={formik.values.address}
                      variant="outlined"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "text.primary",
                          },
                        },
                      }}
                    />
                  </Grid>

                  <Grid item md={4} xs={12}>
                    <FormControl
                      fullWidth
                      variant="outlined"
                      sx={{ my: 1, marginBottom: 2 }}
                    >
                      <TextField
                        select
                        onChange={formik.handleChange}
                        value={formik.values.estado}
                        label="Estado"
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                              borderColor: "text.primary",
                            },
                          },
                        }}
                      >
                        {filterStates.map((estado) => (
                          <MenuItem value={estado.value} key={estado.estado}>
                            {estado.estado}
                          </MenuItem>
                        ))}
                      </TextField>
                    </FormControl>
                  </Grid>
                </Grid>
                {renderMotivoInput()}
              </CardContent>
              <Divider />
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between", // Distribuye los elementos al final y al principio
                  alignItems: "center", // Alinea al centro verticalmente
                  p: 2,
                }}
              >
                <Stack
                  sx={{ width: "auto" }} // Ancho del 60% para el mensaje
                  spacing={2}
                >
                  {isSnackbarOpen && !message.alertType && (
                    <Alert fullWidth severity={message.type}>
                      {message.text}
                    </Alert>
                  )}
                </Stack>
                <LoadingButton
                  loading={loading}
                  color="primary"
                  size="large"
                  type="submit"
                  variant="contained"
                  sx={{ ml: 2 }} // Margen a la izquierda del botón
                >
                  Actualizar
                </LoadingButton>
              </Box>
            </Card>
          </form>
        </Container>
      </Box>

      <Box component="main" sx={{ flexGrow: 1, py: 2 }}>
        <Container maxWidth={false}>
          <Card
            sx={{
              border: "0.5px solid #dddddd",
              padding: "1px",
              boxShadow: "1px 1px #dddddd",
            }}
          >
            <CardHeader
              subheader="Documentación presentada por el usuario"
              title="Documentación"
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "flex-start", md: "center" },
                justifyContent: "space-between",
              }}
              action={
                <Box sx={{ mt: { xs: 2, md: 0 } }}>
                  {userData.documentacion &&
                    userData.documentacion.length < 3 && (
                      <Button
                        component="label"
                        variant="contained"
                        onChange={handleChangeUploadDocumentation}
                        multiple
                        startIcon={<CloudUploadIcon />}
                        sx={{ visibility: approve ? "hidden" : "visible" }}
                      >
                        Subir documentos
                        <VisuallyHiddenInput type="file" />
                      </Button>
                    )}
                </Box>
              }
            />
            {isSnackbarOpen && message.alertType === "document" && (
              <Alert fullWidth severity={message.type}>
                {message.text}
              </Alert>
            )}
            <Divider />
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
              }}
            >
              {userData &&
              userData.documentacion &&
              userData.documentacion.length > 0 ? (
                userData.documentacion.map((doc, index) => (
                  <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: { xs: "flex-start", md: "center" },
                    justifyContent: "space-between",
                    gap: "8px",
                    mb: "8px"
                  }}
                  >
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "flex-start", md: "center" },
                        justifyContent: "space-between",
                        gap: "8px",
                      }}
                    >
                      <LoadingButton
                        variant="outlined"
                        color="primary"
                        loading={false}
                        onClick={() => handleClickDocumentation(doc.s3Link)}
                        sx={{
                          borderRadius: "8px",
                          minWidth: 0,
                          padding: 0,
                          width: "36px",
                          height: "36px",
                          marginRight: "8px",
                        }}
                        loadingPosition="start"
                      >
                        <CloudDownloadOutlinedIcon />
                      </LoadingButton>
                      {!approve && (
                        <LoadingButton
                          variant="outlined"
                          color="error"
                          onClick={() => handleDeleteDocument(doc.id)}
                          sx={{
                            borderRadius: "50%",
                            minWidth: 0,
                            padding: 0,
                            width: "36px",
                            height: "36px",
                          }}
                          loading={false}
                          loadingPosition="start"
                        >
                          <DeleteOutlineIcon />
                        </LoadingButton>
                      )}
                    </Box>
                    <Stack sx={{ width: "100%", ml: "2px", mr: "8px" }} spacing={2}>
                      <Alert fullWidth color="warning" icon={false}>
                        {doc.fileName}
                      </Alert>
                    </Stack>
                  </Box>
                ))
              ) : (
                <p>No hay documentos disponibles.</p>
              )}
            </CardContent>
            <Divider />
          </Card>
        </Container>
      </Box>
    </PageLayout>
  );
};

export default MedicalStaffProfile;
